export const fonts = {
  poppins: '\'Poppins\', \'Poppins-Fallback\', Verdana, sans-serif'
};

export const fontWeights = {
  regular: 400,
  medium: 500,
  semiBold: 600,
  bold: 700
};
